import React from "react";

function ServiceProvides() {
  return (
    <div className="container">
      <div
        className="row"
        style={{ justifyContent: "normal", textAlign: "justify" }}
      >
        <div id="itresourcing" className="border-bottom">
          <h1 className="fs-2" style={{ color: "#000088" }}>
            IT Resourcing
          </h1>
          <p>An organisation needs IT Resourcing when:</p>
          <ul>
            <li>
              The resource requirement of the client is excessive and beyond
              their internal resourcing capability in terms of skill and volume.
            </li>
            <li>
              The resource profile has significant peaks and troughs and you
              only require certain necessary skills for relatively short
              periods.
            </li>
            <li>
              A project is suffering from resource attrition and is also losing
              knowledge at end of its life.
            </li>
          </ul>
          <p>
            Our IT resourcing and support systems can help in reducing your
            total capital spending and it even produces a focused and committed
            team that is always ready to help. Most businesses nowadays require
            IT support but they cannot afford the luxury of employing personnel
            on a full or even part-time basis. Several large businesses have
            started outsourcing their IT departments to specialised companies to
            improve their efficiencies and save money.
          </p>
          <p>
            IT Resourcing can provide a company with options for both long-term
            as well as filling short-term and interim gaps due to any unforeseen
            circumstances. You are assured that a professional and competent
            service would be catered according to your requirements. We realise
            the relevance of IT in adding value, efficiency, and enhancing the
            overall performance of the business.
          </p>
          <p>
            We understand the needs of both our clients and the consultant. We
            coordinate with our clients to understand their specific needs and
            are committed provide quality and cost-effective service that would
            be beneficial to them. Our IT Resourcing offers a strategic service
            that focuses on sourcing high-calibre candidates for contract and
            permanent positions.
          </p>
          <p>
            Our core focus is on IT, which means we have a unique understanding
            and knowledge of the IT industry that allows us to provide one-stop
            solutions for clients in their search for the best technical talent.
            We have a pool of highly qualified consultants who can be made
            available to meet the immediate needs of the clients.
          </p>
          <p>
            We also perform rigorous assessments against their specific
            requirements along with maintaining a level of transparency around
            resource management (source and cost). Whether you need to resource
            an entire project team or just a single position, we can introduce
            you to the exact talent that you need.
          </p>
        </div>

        <div id="itconsulting" className="mt-3 border-bottom">
          <h1 className="fs-2" style={{ color: "#000080" }}>
            IT Consulting
          </h1>
          <p>
            Organisations that are facing challenges due to disruptive
            technology through cloud, mobility and digital technologies are
            facing the impact on their IT systems and workforce. This often can
            make it difficult to create and bring innovative solutions and
            products to their business.
          </p>
          <p>
            Our IT consulting team can provide the means and knowledge that
            would help the clients in overcoming their challenges. Our
            consultants are aware of the new disruptive technology. They also
            have the necessary skills, tools and methods that can help you to
            gain agility while integrating and maintaining your applications and
            business processes. We work end-to-end across all dimensions to
            deliver the result.
          </p>
        </div>

        <div id="itservices" className="mt-3">
          <h1 className="fs-2" style={{ color: "#000080" }}>
            IT Services
          </h1>
          <p>
            IT FutureTech has a deep understanding and knowledge about the
            automation needs of the client’s business along with its technical
            expertise and streamlined software development life cycle processes
            that allow to develop and maintain the customised business
            applications along with the quality standards. Software applications
            are the backbone for any organization that enable them to perform
            the functions of the business effectively and efficiently.
          </p>
          <p>
            However, organisations face challenges with various obstacles while
            managing the critical applications of their business across the
            spectrum of application lifecycle in order to maintain the
            sustainable performance of the business.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ServiceProvides;
